import { GeneralModel } from "./general.model";

export class Cod extends GeneralModel {
}